import { useRouter } from "../router";
import { InvestorPicker } from "./portfolio/InvestorPicker";
import { InvestorPortfolioView } from "./portfolio/InvestorPortfolio";
import { AccountDetail } from "./portfolio/AccountDetail";
import { Placeholder } from "../components/Placeholder";

export function Portfolio() {
  const { pathname } = useRouter();
  const sub = pathname.split("/").filter(Boolean).slice(2);

  if (sub.length === 0) return <InvestorPicker />;

  if (sub[0] === "accounts" && sub[1]) {
    const accountId = Number(sub[1]);
    if (!Number.isInteger(accountId) || accountId <= 0) return <NotFound />;
    return <AccountDetail id={accountId} />;
  }

  const investorId = Number(sub[0]);
  if (!Number.isInteger(investorId) || investorId <= 0) return <NotFound />;
  if (sub.length === 1) return <InvestorPortfolioView id={investorId} />;

  return <NotFound />;
}

function NotFound() {
  return (
    <Placeholder
      eyebrow="Portfolio"
      title="Page not found."
      lede="That page doesn't exist."
      milestone="Back to investors"
    />
  );
}
